import type { PropsWithChildren } from 'react'
import { createContext } from 'react'
import type { BrandTheme } from '../../types/BrandTheme'

export interface BrandContextValue {
  theme: BrandTheme
}
export const BrandContext = createContext<BrandContextValue | undefined>(
  undefined,
)
export function BrandContextProvider({
  theme,
  children,
}: PropsWithChildren<{ theme: BrandTheme }>) {
  return (
    <BrandContext.Provider
      value={{
        theme,
      }}
    >
      {children}
    </BrandContext.Provider>
  )
}
